import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'scriptRequest', en);

const ScriptRequestLogConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Script Request Reports',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.REPORT,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/script-request/log',
      component: React.lazy(() => import('./ScriptRequestLog')),
    },
  ],
};

export default ScriptRequestLogConfig;
